exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test {\n  height: 100%;\n  font-size: 0.28rem;\n  padding: 0.2rem;\n  line-height: 0.52rem;\n}\n.test button {\n  width: 30%;\n  height: 50px;\n}\n.test table,\n.test td {\n  border: 1px solid #515151;\n}\n.test table img,\n.test td img {\n  width: 100px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/test/test/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/test/test/index.less
// module chunks = 0